import React from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/images/Rankifydev-wlogo.png";
import { projects } from "../data/projects";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-[hsl(var(--brand-navy))] text-white overflow-hidden" data-testid="site-footer">
      <div className="absolute -top-20 -right-20 h-72 w-72 rounded-full brand-gradient blur-3xl opacity-30" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="[&_.text-brand-deep/70]:!text-[hsl(var(--brand-amber))] [&_span]:!text-white">
              <img
            src={Logo}
            alt="RankifyDev Logo"
            className="w-auto"
          style={{height: "4em"}}/>
            </div>
            <p className="mt-5 text-white/60 max-w-md leading-relaxed">
              A division of Webify IT Solutions - building SEO-focused websites and AI-visibility strategies that turn traffic into revenue.
            </p>
          </div>
          <div>
            <div className="text-[11px] uppercase tracking-widest text-[hsl(var(--brand-amber))] mb-4">Explore</div>
            <ul className="space-y-2 text-sm text-white/70">
              <li><a href="/#services" className="hover:text-white">Services</a></li>
              <li><a href="/#about" className="hover:text-white">About</a></li>
              <li><a href="/#process" className="hover:text-white">Process</a></li>
              <li><Link to="/portfolio" className="hover:text-white">Portfolio · {projects.length}+</Link></li>
              <li><Link to="/blog" className="hover:text-white">Blog</Link></li>
              <li><a href="/#faq" className="hover:text-white">FAQ</a></li>
            </ul>
          </div>
          <div>
            <div className="text-[11px] uppercase tracking-widest text-[hsl(var(--brand-amber))] mb-4">Services</div>
            <ul className="space-y-2 text-sm text-white/70">
              <li><a href="/novafy" className="hover:text-white">Novafy</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div>© {year} Rankify Dev · A part of <a className="text-[hsl(var(--brand-amber))]" href="https://webifyitsolutions.com/" target="_blank"> <strong>Webify IT Solutions</strong></a>. All rights reserved.</div>
          <div className="flex gap-4">
            <span>Privacy</span>
            <span>Terms</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
